import { useMemo } from "react"
import { ConditionGroup } from "@/schema"

import { useInfiniteMeetingFeed } from "./queries"

export function useMeetingsPageData(options?: {
  viewType?: "upcoming" | "processed"
  userIds?: string[]
  conditionGroup?: ConditionGroup
  search?: string
}) {
  const feedQuery = useInfiniteMeetingFeed({
    scope: options?.viewType ?? "upcoming",
    userIds: options?.userIds,
    conditionGroup: options?.conditionGroup,
    search: options?.search,
    enabled: options?.viewType !== undefined,
  })

  const meetings = useMemo(() => feedQuery.data?.meetings ?? [], [feedQuery.data?.meetings])

  return {
    meetings,
    isLoading: feedQuery.isLoading,
    isFetchingNextPage: feedQuery.isFetchingNextPage,
    fetchNextPage: feedQuery.fetchNextPage,
    hasNextPage: Boolean(feedQuery.hasNextPage),
  }
}
